import React, { useMemo } from 'react';
import { useIonRouter } from '@ionic/react';
import PageLayout from '../../components/PageLayout';
import { FEData, FEDataEL, FETableInner } from '@hdcorner/ui-library';

const FoodEquivalentsTable = () => {
  const router = useIonRouter();

  const lang: 'en' | 'el' = (localStorage.getItem('i18nextLng') as 'en' | 'el') || 'en';

  const feEN = FEData();
  const feEL = FEDataEL();

  const selection = router?.routeInfo?.pathname?.split('/').slice(-1);
  const category = useMemo(() => {
    if (lang === 'el') return feEL.find((it: any) => it.type === selection[0]);
    return feEN.find((it: any) => it.type === selection[0]);
  }, [lang]);
  const title = category?.title || '';

  return (
    <PageLayout headerTitle={title}>
      <FETableInner header={title} lang={lang} />
    </PageLayout>
  );
};

export default FoodEquivalentsTable;
